import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Avatar,
    Button,
    Box,
    TextField,
    Grid
} from '@mui/material';
import { Close } from "@mui/icons-material";

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// Esquema de validación
const schema = yup.object().shape({
    comment: yup.string().required("El comentario no puede estar vacío").max(500),
});

export const CommentModals = ({
    open,
    handleClose,
    currentUser,
    comentarios = [],
    onSendComment,
    onDeleteComment,
    onEditComment,
}) => {
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [displayAddComment, setDisplayAddComment] = useState(false);

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            comment: ""
        }
    });

    const handleAddClick = () => {
        setEditingCommentId(null); // limpiar edición
        reset();
        setDisplayAddComment(true);
    };

    const handleSendClick = (data) => {
        if (editingCommentId) {
            onEditComment(editingCommentId, data.comment);
        } else {
            onSendComment(data.comment);
        }

        reset();
        setDisplayAddComment(false);
        setEditingCommentId(null);
    };

    const handleEditClick = async (comment) => {
        setDisplayAddComment(true);
        setEditingCommentId(comment);
        setValue("comment", comment.text);
    };

    const handleCancelEdit = () => {
        setDisplayAddComment(false);
        reset();
        setEditingCommentId(null);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Comentarios
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6}>
                        <Button
                            variant="contained"
                            color="primary"
                            size='small'
                            onClick={handleAddClick}
                        >
                            Agregar Comentario
                        </Button>
                    </Grid>
                </Grid>

                {displayAddComment && (
                    <Box
                        component="form"
                        onSubmit={handleSubmit(handleSendClick)}
                        sx={{ mt: 2 }}
                    >
                        <Grid container spacing={2} direction="column">
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    minRows={3}
                                    maxRows={6}
                                    placeholder="Escribe tu comentario..."
                                    {...register("comment")}
                                    error={!!errors.comment}
                                    helperText={errors.comment?.message}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    {editingCommentId ? "Guardar cambios" : "Enviar"}
                                </Button>
                                {editingCommentId && (
                                    <Button
                                        onClick={handleCancelEdit}
                                        variant="text"
                                        color="secondary"
                                        sx={{ ml: 2 }}
                                    >
                                        Cancelar
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                )}

                <Box sx={{ mt: 3, borderTop: 1, borderColor: 'grey.300', pt: 2 }}>
                    <Grid container spacing={2} direction="column">
                        {comentarios.length > 0 ? (
                            comentarios.map(comment => (
                                <Grid
                                    container
                                    spacing={2}
                                    key={comment.id}
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Grid item sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                        <Avatar>{comment.avatar}</Avatar>
                                        <Box>
                                            <Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {comment.name}
                                                {!comment.is_read && (
                                                    <span style={{ color: 'red', fontSize: '1.2em', lineHeight: 1 }}>●</span>
                                                )}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {comment.text}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    {comment.userId == currentUser.id && (
                                        <Grid item>
                                            <Button
                                                size="small"
                                                onClick={() => handleEditClick(comment)}
                                            >
                                                Editar
                                            </Button>
                                            <Button
                                                size="small"
                                                color="error"
                                                onClick={() => onDeleteComment(comment.id)}
                                            >
                                                Eliminar
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            ))
                        ) : (
                            <Typography align="center">No hay comentarios</Typography>
                        )}
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    );
};